import './styles.scss';
import { Link } from 'react-router-dom'

type Button = 'primary' | 'secondary'
type Props = {
    path: string
    text: string
    type: Button
}

function LinkButton(props: Props) {
    return (
        <Link to={props.path} className={`link-button ${props.type}`}>
            {props.text}
        </Link>
    )
}

export default LinkButton;
